import { createInstance, InitOptions } from 'i18next';
import { initReactI18next } from 'react-i18next/initReactI18next';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import { Languages } from '@/constants/common';
import az from '@/locales/az.json';
import ru from '@/locales/ru.json';
import { CONFIG } from '@/constants/config';

export const i18nOptions: InitOptions = {
  debug: false,
  fallbackLng: 'az',
  load: 'languageOnly',
  resources: {
    az: { translation: az },
    ru: { translation: ru },
  },
  supportedLngs: CONFIG.languages,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'span'],
  },
  detection: {
    order: ['langdomain'],
  },
};

export async function initI18nextServer(lng: Languages) {
  const i18n = createInstance();

  await i18n
    .use(initReactI18next)
    .use(intervalPlural)
    .init({
      lng,
      initImmediate: false,
      ...i18nOptions,
    });

  return i18n;
}

const serverI18nCache = new Map<Languages, ReturnType<typeof createInstance>>();

export function getServerI18n(lng: Languages) {
  const cached = serverI18nCache.get(lng);
  if (cached) return cached;

  const instance = createInstance();
  instance
    .use(initReactI18next)
    .use(intervalPlural)
    .init({
      lng,
      initImmediate: false,
      ...i18nOptions,
    });

  serverI18nCache.set(lng, instance);
  return instance;
}
